module.exports = __webpack_public_path__ + "static/img/SallyFitzgibbons.40f7e1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SallyFitzgibbons.jpg
// module id = ufuI
// module chunks = 0